/**
 * Utilidades para mostrar notificaciones toast usando react-toastify
 */
import { toast } from 'react-toastify';

// Configuración por defecto para los toasts
const defaultConfig = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

/**
 * Muestra una notificación de éxito
 * @param {string} message - Mensaje a mostrar
 * @param {Object} options - Opciones adicionales para el toast
 */
export const toastSuccess = (message, options = {}) => {
  toast.success(message, { ...defaultConfig, ...options });
};

/**
 * Muestra una notificación de error
 * @param {string} message - Mensaje a mostrar
 * @param {Object} options - Opciones adicionales para el toast
 */
export const toastError = (message, options = {}) => {
  toast.error(message, { ...defaultConfig, ...options });
};

/**
 * Muestra una notificación de información
 * @param {string} message - Mensaje a mostrar
 * @param {Object} options - Opciones adicionales para el toast
 */
export const toastInfo = (message, options = {}) => {
  toast.info(message, { ...defaultConfig, ...options });
};

/**
 * Muestra una notificación de advertencia
 * @param {string} message - Mensaje a mostrar
 * @param {Object} options - Opciones adicionales para el toast
 */
export const toastWarning = (message, options = {}) => {
  toast.warning(message, { ...defaultConfig, ...options });
};

/**
 * Muestra una notificación personalizada
 * @param {string} message - Mensaje a mostrar
 * @param {Object} options - Opciones adicionales para el toast
 */
export const toastCustom = (message, options = {}) => {
  toast(message, { ...defaultConfig, ...options });
};

/**
 * Muestra una notificación con promesa
 * @param {Promise} promise - Promesa a esperar
 * @param {Object} messages - Objeto con mensajes para cada estado {pending, success, error}
 * @param {Object} options - Opciones adicionales para el toast
 */
export const toastPromise = (promise, messages = {}, options = {}) => {
  const { pending = 'Cargando...', success = 'Completado con éxito!', error = 'Ha ocurrido un error' } = messages;
  
  return toast.promise(
    promise,
    {
      pending: pending,
      success: success,
      error: error,
    },
    { ...defaultConfig, ...options }
  );
};

/**
 * Actualiza la configuración por defecto de los toasts
 * @param {Object} newConfig - Nueva configuración por defecto
 */
export const settingsToasts = (newConfig = {}) => {
  Object.assign(defaultConfig, newConfig);
};
